import { merge } from 'lodash'
import { currency, TYPES as CURRENCY_TYPES } from './currency/store'

const store = {
  GENERIC: {
    namespaced: true,
    modules: {
      currency: {
        namespaced: true,
        modules: {
          currency
        }
      }
    }
  }
}

const TYPES = () =>
  merge(
    CURRENCY_TYPES
  )

export { store, TYPES }
